import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

import {DialogMessage} from './dialog-message.model';
import {GlobalVariable} from '../../global';
import { ConfigLoaderService } from '../../app-loader/config-loader.service';
import { PlatformConfig } from '../../app-loader/platform-config';

@Component({
  selector: 'app-dialog-messages',
  templateUrl: './dialog-messages.component.html',
  styleUrls: ['./dialog-messages.component.scss']
})
export class DialogMessagesComponent implements OnInit {

  requestDebugMode: boolean = GlobalVariable.DEBUG_REQUESTS_MODE;
  error: any = null;
  platformConfig: PlatformConfig;

  constructor(public dialogRef: MatDialogRef<DialogMessagesComponent>,
              @Inject(MAT_DIALOG_DATA) public dialogMessage: DialogMessage,
              public configLoaderService: ConfigLoaderService) {
      this.platformConfig = this.configLoaderService.getPlatformConfig();
    }

  ngOnInit() {
    console.log(this.dialogMessage.message);
    this.error = JSON.parse(this.dialogMessage.message.error);
  }

  getMessages() {
    if (this.isFormError()) {
      return this.getFormErrors();
    }
    return this.getArrayFromObject(this.error);
  }

  getDebugMessages() {
    const message = this.dialogMessage.message;
    const returnArray = [];

    returnArray.push({'key': 'status', 'value': message.status});
    returnArray.push({'key': 'statusText', 'value': message.statusText});
    returnArray.push({'key': 'url', 'value': message.url});
    returnArray.push({'key': 'error', 'value': message.error});
    returnArray.push({'key': 'message', 'value': message.message});
    returnArray.push({'key': 'X-Debug-Token-Link', 'value': message.headers.get('X-Debug-Token-Link')});

    return returnArray;
  }

  private getFormErrors() {
    const returnArray = [];
    const formErrors = this.error.children;
    for (const key in formErrors) {
      if (formErrors.hasOwnProperty(key)) {
        if (formErrors[key].errors !== null && formErrors[key].errors !== undefined) {
          const errors = [];
          for (const errorKey in formErrors[key].errors) {
            if (formErrors[key].errors.hasOwnProperty(errorKey)) {
              errors.push({'key': errorKey, 'value': formErrors[key].errors[errorKey]});
            }
          }
          returnArray.push({'key': key, 'value': errors});
        }
      }
    }
    return returnArray;
  }

  private getArrayFromObject(object: Object) {
    const returnArray = [];
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (typeof object[key] === 'object') {
          returnArray.push({'key': key, 'value': this.getArrayFromObject(object[key])});
        } else {
          returnArray.push({'key': key, 'value': object[key]});
        }
      }
    }
    return returnArray;
  }

  isValueObject(value) {
    return typeof value === 'object';
  }

  isFormError() {
    return this.dialogMessage.message.status === 400 && this.error.message === undefined;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/dialog-messages/dialog-messages.component.ts